import script from "./Together.vue?vue&type=script&setup=true&lang=js"
export * from "./Together.vue?vue&type=script&setup=true&lang=js"

import "./Together.vue?vue&type=style&index=0&id=525ddbc0&lang=scss"

const __exports__ = script;

export default __exports__